/**
 * Sérialisation options/choix pour save Produit Admin.
 * Retire les enrichissements GET (linkedProduit, linkedProduitCommandable).
 * Aligné sur backend/validations/produitsValidation choixOptionInputSchema.
 */

import { isPersistedPrismaId } from './persistedEntityId.js';

/** Exactement les clés de choixOptionInputSchema (Joi) — hors enrichissements GET. */
const CHOIX_SAVE_KEYS = new Set([
  'id',
  'optionProduitId',
  'createdAt',
  'updatedAt',
  'nom',
  'description',
  'prix',
  'ordre',
  'actif',
  'linkedProduitId',
]);

/**
 * @param {Record<string, unknown>|null|undefined} choix
 */
export function serializeChoixOptionForSave(choix) {
  if (!choix || typeof choix !== 'object') {
    return choix;
  }

  /** @type {Record<string, unknown>} */
  const out = {};
  for (const key of CHOIX_SAVE_KEYS) {
    if (key === 'id' && !isPersistedPrismaId(choix.id)) {
      continue;
    }
    if (key === 'linkedProduitId') {
      if ('linkedProduitId' in choix) {
        out.linkedProduitId = choix.linkedProduitId || null;
      }
      continue;
    }
    if (choix[key] !== undefined) {
      out[key] = choix[key];
    }
  }

  if (out.nom === undefined && choix.nom != null) {
    out.nom = choix.nom;
  }

  return out;
}

/**
 * @param {Array<Record<string, unknown>>|null|undefined} options
 */
export function serializeProduitOptionsForSave(options) {
  return (options || [])
    .filter((opt) => opt?.nom && Array.isArray(opt.choix) && opt.choix.length > 0)
    .map((opt) => {
      const isMulti =
        opt.type === 'CHOIX_MULTIPLE' ||
        (opt.choixMultiple && opt.type !== 'CHOIX_UNIQUE');
      const { maxIllimite, id: optId, ...rest } = opt;
      return {
        ...rest,
        ...(isPersistedPrismaId(optId) ? { id: optId } : {}),
        type: opt.type || (opt.choixMultiple ? 'CHOIX_MULTIPLE' : 'CHOIX_UNIQUE'),
        choixMultiple: isMulti,
        choixMaximum:
          isMulti && maxIllimite ? null : isMulti ? opt.choixMaximum : 1,
        nbInclus: isMulti ? Math.max(0, parseInt(String(opt.nbInclus), 10) || 0) : 0,
        choix: (opt.choix || []).map(serializeChoixOptionForSave),
      };
    });
}
